import baseDataProvider, { httpClient } from "../baseDataProvider";
import { ATS_API_URL, OLD_DOCUPLOAD_API } from "../../config";
import {
    handleAdverseLetter, handleBankDoc, handleCompanyType,
    handleContextualGetDetails, handleGetActiveDataGraph,
    handleGetApplicantDetails, handleGetApplicationInboxDetails,
    handleGetApplicationProfileDetails, handleGetBankValidationCheck, handleGetDownloadDocumentsMessage,
    handleGetEmployerValidationCheck, handleGetIdentification, handleGetIDValidationCheck, handleGetIpAddress,
    handleGetLookbacks, handleGetPayment, handleGetPropertyDetails, handleGetQueueCount, handleGetSectionAvailable,
    handleGetStripeDetails, handleGetSubscriber, handleGetSubscriberConfigurations, handleGetSubscriberCount,
    handleGetSubscriberManagerAndLeads, handleGetSubscriberProfileSectionNew, handleGetTandCPageForPayment,
    handleGetTermsCondition, handleGetTermsConditionLandlord, handleGetThirdPartyApps, handleGetTokkenDetails,
    handleIncome, handleIntegrationSettingRule, handleListThirdPartyApps, handleMlClassDetails,
    handleOtherIncomeDoc, handleProofOfIdsData, handleScreeningCompany, handleSsnGetIdentification,
    handleSubscriberScreeningCompany, handleSubscriberThirdPartyMenu,
    handleViewAdverseLetter, handleViewAppReport, handleGetApplicants, handleGetStates,
    handleGetMetaData, handleGetApplicationGraph, handleGetApplicationCountStatus,
    handleDocUploadManagementStats, handleVerificationManagementStats,
    handleGetFilterForInbox, handleGetNewApplicationDetail, handleGetAllDocs,
    handleGetSecondaryApp, handleRegistrationPage, handleGetDataPolicy, handleGetTermsOfUse,
    handleOtherDoc, handleMlBankList, handleGetGraphData,
    handleApplicationProfile,
    handleLeaseTemplate, handleGetBankIncomeValidationCheck, handleGetPlaidBankIncomeEnabled,
    handleGetPlaidPayrollIncomeEnabled, handleGetPayrollIncomeValidationCheck,
    handleGetArgyleBankIncomeEnabled, handleGetArgylePayrollIncomeEnabled,
    handleGetArgylePayrollIncomeValidationCheck, handleGetArgyleBankIncomeValidationCheck, handleGetIncomeVerificationProvider,
    handleGetRiskIndicatorIsFraudRisk

} from "./getOneHandler";
const API_URL = ATS_API_URL;
const API_URL_DOC = `${API_URL}/applicant`;

const resourceHandlers: Record<string, (params: any) => Promise<any>> = {
  "getapplicationprofiledetails": handleGetApplicationProfileDetails,
  "getsubscribermanagerandleads": handleGetSubscriberManagerAndLeads,
  "viewadverseletter": handleViewAdverseLetter,
  "getEmployerValidationCheck": handleGetEmployerValidationCheck,
  "getBankValidationCheck": handleGetBankValidationCheck,
  "getIDValidationCheck": handleGetIDValidationCheck,
  "getTermsCondition": handleGetTermsCondition,
  "getTermsConditionLandlord": handleGetTermsConditionLandlord,
  "getsectionavailable": handleGetSectionAvailable,
  "getTokkenDetails": handleGetTokkenDetails,
  "getApplicantDetails": handleGetApplicantDetails,
  "mlclassdetails": handleMlClassDetails,
  "getSubscriberProfileSection_new": handleGetSubscriberProfileSectionNew,
  "proofOfIdsData": handleProofOfIdsData,
  "income": handleIncome,
  "bankDoc": handleBankDoc,
  "otherIncomeDoc": handleOtherIncomeDoc,
  "otherDoc": handleOtherDoc,
  "getMetaData": handleGetMetaData,
  "getapplicationgraph": handleGetApplicationGraph,
  "getapplicationcountstatus": handleGetApplicationCountStatus,
  "docuploadmanagementstats": handleDocUploadManagementStats,
  "verificationmanagementstats": handleVerificationManagementStats,
  "getfilterforinbox": handleGetFilterForInbox,
  "getnewapplicationdetail": handleGetNewApplicationDetail,
  "getipaddress": handleGetIpAddress,
  "getapplicationinboxdetails": handleGetApplicationInboxDetails,
  "getidentification": handleGetIdentification,
  "ssnGetidentification": handleSsnGetIdentification,
  "getTandCpageforpayment": handleGetTandCPageForPayment,
  "getpayment": handleGetPayment,
  "contextualgetdetails": handleContextualGetDetails,
  "getsubscribercount": handleGetSubscriberCount,
  "getqueuecount": handleGetQueueCount,
  "getactivedatagraph": handleGetActiveDataGraph,
  "getgraphdata": handleGetGraphData,
  "mlbanklist": handleMlBankList,
  "getalldocs": handleGetAllDocs,
  "getSecondaryApp": handleGetSecondaryApp,
  "getdatapolicy": handleGetDataPolicy,
  "gettermsofuse": handleGetTermsOfUse,
  "registrationpage": handleRegistrationPage,
  "viewappreport": handleViewAppReport,
  "getApplicants": handleGetApplicants,
  "getStates": handleGetStates,
  "application-profile": handleApplicationProfile,
  "lease-template": handleLeaseTemplate,
  "get-third-party-apps": handleGetThirdPartyApps,
  "subscriber-screening-company": handleSubscriberScreeningCompany,
  "adverse-letter": handleAdverseLetter,
  "get-property-details": handleGetPropertyDetails,
  "integration-setting-rule": handleIntegrationSettingRule,
  "list-third-party-apps": handleListThirdPartyApps,
  "screening-company": handleScreeningCompany,
  "company-type": handleCompanyType,
  "get-subscriber": handleGetSubscriber,
  "subscriber-third-party-menu": handleSubscriberThirdPartyMenu,
  "get-stripe-details": handleGetStripeDetails,
  "getDownloadDocumentsMessage": handleGetDownloadDocumentsMessage,
  "getlookbacks": handleGetLookbacks,
  "get-subscriber-configurations": handleGetSubscriberConfigurations,
  "plaidBankIncomeValidationCheck":  handleGetBankIncomeValidationCheck,
  "plaid/bankIncomeValidationCheck": handleGetBankIncomeValidationCheck,
  "plaidPayrollIncomeValidationCheck": handleGetPayrollIncomeValidationCheck,
  "plaid/plaidBankIncomeEnabled": handleGetPlaidBankIncomeEnabled,
  "plaid/plaidPayrollIncomeEnabled": handleGetPlaidPayrollIncomeEnabled,
  "argyle/argyleBankIncomeEnabled": handleGetArgyleBankIncomeEnabled,
  "argyle/argylePayrollIncomeEnabled": handleGetArgylePayrollIncomeEnabled,
  "argylePayrollIncomeValidationCheck": handleGetArgylePayrollIncomeValidationCheck,
  "argyleBankIncomeValidationCheck": handleGetArgyleBankIncomeValidationCheck,
  "incomeVerificationProvider": handleGetIncomeVerificationProvider,
  "riskIndicatorIsFraudRisk": handleGetRiskIndicatorIsFraudRisk,
};

const getOne = async (resource, params) => {
  if (resourceHandlers[resource]) {
    return resourceHandlers[resource](params);
  }
  return baseDataProvider.getOne(resource, params);
};

export default getOne;
